module.exports = __webpack_public_path__ + "media/images/emblems/Poliez-Pittet-73a11cdeb6721b35171a3997488b596b.png";